export default "__VITE_ASSET__D2$2b9Kg__"